import Ajax from 'util/ajax';
import * as Analytics from 'modules/analytics';
import 'util/i18n';
import { setup as accessibility } from 'modules/accessibility';
import { setup as sidebar } from 'modules/sidebar';
import { setup as settings } from 'modules/settings';
import { setup as admin_panel } from 'modules/admin_panel';
import { setup as sessions } from 'modules/sessions';
import { setup as react_helper } from 'modules/react_helper';
import { setup as tooltips } from 'modules/tooltips';
import { setup as saved_searches } from 'modules/saved_searches';
import { setup as release_check } from 'modules/release_check';
import { setup as stale_bundle } from 'modules/stale_bundle';
import { setup as explorer } from 'modules/explorer';

// Make some modules available globally
window.Analytics = Analytics;

// JS-capable browsers get an attribute on the HTML tag as soon as we run the JS
// - this allows us to handle JS-specific styles in a clean way, with no FOUC
const htmlElement = document.getElementsByTagName('html')[0];
const newHTMLClass = document.documentElement.className.replace('no-js', 'js');
htmlElement.setAttribute('class', newHTMLClass);

// Before anything can lazily load part of the bundle
stale_bundle();
accessibility();
sidebar();
settings();
admin_panel();
sessions();
react_helper();
tooltips();
saved_searches();
release_check();

// Loads new JS-based (React) UI
explorer();

window.Analytics.setup();
Ajax.setup();
